(() => {
  const PRODUCT_HANDLE = 'wood-therapy-massage-set';
  const bundleMap = {'1 Set':2,'2 Sets':4,'3 Sets':6,'4 Sets':8};

  const activeCurrency = () => window.Shopify?.currency?.active || window.Shopify?.currency?.rate && window.Shopify?.currency?.active || 'USD';
  const formatMoney = cents => {
    const currency = activeCurrency();
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style:'currency', currency, currencyDisplay:'narrowSymbol',
        minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch(error) {
      return `$${amount.toFixed(Number.isInteger(amount) ? 0 : 2)}`;
    }
  };

  async function fixBundlePrices(){
    const ladder = document.querySelector('.aureko-bundle-ladder');
    if(!ladder) return;
    try {
      const response = await fetch(`/products/${PRODUCT_HANDLE}.js`, {headers:{Accept:'application/json'}});
      if(!response.ok) return;
      const product = await response.json();
      Object.entries(bundleMap).forEach(([variantTitle,pieces]) => {
        const variant = product.variants?.find(item => item.title === variantTitle);
        const card = ladder.querySelector(`.aureko-bundle-choice[href*="pieces=${pieces}"]`);
        if(!variant || !card) return;
        const price = card.querySelector('.aureko-bundle-choice__price');
        const perPiece = price?.nextElementSibling;
        if(price) price.textContent = formatMoney(variant.price);
        if(perPiece) perPiece.textContent = `${formatMoney(variant.price / pieces)}/piece`;
      });
    } catch(error) {}
  }

  function upgradeFinal(){
    const section = document.querySelector('.aureko-final');
    if(!section) return;
    section.classList.add('aureko-final--upgraded');
    const kicker = section.querySelector('.aureko-kicker');
    const title = section.querySelector('h2');
    const copy = section.querySelector('p');
    const cta = section.querySelector('a.aureko-btn');
    if(kicker) kicker.textContent = 'READY WHEN YOU ARE';
    if(title) title.textContent = 'Build the ritual around you.';
    if(copy) copy.textContent = 'Choose the tools you’ll actually use, repeat your favorites, and start with the bundle size that fits your routine.';
    if(cta){
      cta.textContent = 'Build my ritual →';
      cta.href = `/products/${PRODUCT_HANDLE}?pieces=6#AurekoBundlePicker`;
    }
    if(!section.querySelector('.aureko-final__proof')){
      const proof = document.createElement('div');
      proof.className = 'aureko-final__proof';
      proof.innerHTML = '<span>CHOOSE ANY COMBINATION</span><span>REPEAT FAVORITES</span><span>6-PIECE SWEET SPOT</span>';
      if(copy) copy.after(proof);
    }
  }

  const init = () => { upgradeFinal(); fixBundlePrices(); };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
